import api from "@/lib/api";
import { toast } from "sonner";

// Integração específica com WhatsApp removida. Compartilhamento genérico pelo dispositivo (Web Share) com fallback para copiar.
// Nunca registra "enviada": apenas copiada/compartilhada.
export const compartilharTexto = async ({ texto, titulo = "Mensagem", cliente_id, evento = "manual", categoria = "Manual", ref = "", telefone = "", mensagem_id = null }) => {
  let status = "copiada";
  if (navigator.share) {
    try { await navigator.share({ title: titulo, text: texto }); status = "compartilhada"; }
    catch (e) { if (e?.name === "AbortError") return null; status = await copiar(texto); }
  } else status = await copiar(texto);
  if (!status) return null;
  try {
    if (mensagem_id) { await api.post(`/mensagens/${mensagem_id}/status`, { status, texto }); return mensagem_id; }
    if (cliente_id) { const r = await api.post("/mensagens/registrar", { cliente_id, titulo, texto, telefone, evento, categoria, ref, status }); return r.data?.id; }
  } catch { /* histórico opcional */ }
  return status;
};

const copiar = async (texto) => {
  try { await navigator.clipboard.writeText(texto); toast.success("Texto copiado — cole no aplicativo de sua preferência."); return "copiada"; }
  catch { toast.error("Não foi possível copiar o texto."); return null; }
};

export const enviarWhatsApp = compartilharTexto;
